import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Progressive enhancement: tag <html> with `js` so CSS can scope
// pre-animation hidden states to JS-capable browsers only.
// With JS disabled or the observer never firing, content stays visible.
if (typeof document !== 'undefined') {
  document.documentElement.classList.add('js');
}
render(<App data-id="element-360" />, document.getElementById('root'));